export default __webpack_public_path__ + "static/media/coordination_with_humanitarians.3f7bfc23.jpg";